import { render, staticRenderFns } from "./PicImage.vue?vue&type=template&id=6946d34c&scoped=true"
import script from "./PicImage.vue?vue&type=script&lang=js"
export * from "./PicImage.vue?vue&type=script&lang=js"
import style0 from "./PicImage.vue?vue&type=style&index=0&id=6946d34c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946d34c",
  null
  
)

export default component.exports